var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455.1 455.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227.6,
    cy: 227.6,
    r: 227.6,
    fill: "#bf1d1d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bf1d1d",
    d: "M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6-72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5-72.6 72.5c-8.5 8.5-22.8 8.5-31.3 0s-8.5-22.8 0-31.3l72.5-72.5-72.5-72.6c-8.5-8.5-8.5-22.8 0-31.3s22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0s8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5c8.6 8.6 8.6 22.8.1 31.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default ForwardRef;